import {
  apiRequest,
  successfulResponseHandler,
  unsuccessfulResponseHandler,
  fetchPlans,
  formUrlencodedHeaders,
} from '@recurrent/shared/build/api';

export const fetchChargeInfo = (email) =>
  apiRequest
    .get(`is-user-chargeable/${email}`)
    .then(successfulResponseHandler)
    .catch(unsuccessfulResponseHandler);

export const fetchReactivationCapability = () =>
  apiRequest
    .get('should-pay-for-reactivation/')
    .then(successfulResponseHandler)
    .catch(unsuccessfulResponseHandler);

export const login = (data) =>
  apiRequest
    .post('login', data, {
      headers: formUrlencodedHeaders,
    })
    .then(successfulResponseHandler)
    .catch(unsuccessfulResponseHandler);

export const fetchFullPricePlans = () =>
  fetchPlans({
    without_coupons: true,
  });

export const fetchAccount = (params) =>
  apiRequest
    .get('account', { params })
    .then(successfulResponseHandler)
    .catch(unsuccessfulResponseHandler);
